import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
//import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
//import { ToastrService } from 'ngx-toastr';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';
import { CallDetailLogModel, CallLogModel } from 'src/app/shared/models/calllog.model';
import { ClientModel } from 'src/app/shared/models/client.model';
import { IssueModel, IssueTrackModel } from 'src/app/shared/models/issue.model';
import { UserModel } from 'src/app/shared/models/user.model';
import { CallLogService } from 'src/app/shared/services/calllog.service';
import { ClientService } from 'src/app/shared/services/client.service';
import { IssueTrackService } from 'src/app/shared/services/issue-track.service';
import { IssueService } from 'src/app/shared/services/issue.service';
import { UserService } from 'src/app/shared/services/user.service';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-calllog-detail',
  templateUrl: './calllog-detail.component.html',
  styleUrls: ['./calllog-detail.component.css']
})
export class CallLogDetailComponent implements OnInit, OnDestroy{
  //dialogData :any;
  issue : IssueModel;
  issueTracks : IssueTrackModel [];
  sub : any;
  form = CallLogModel.getFormGroup();
  currentData : CallDetailLogModel;
  users : UserModel [];
  currentClient : ClientModel;

  constructor(
    private issueService: IssueService,
    private trackService: IssueTrackService,
    private clientService : ClientService,
    private userService : UserService,
    private service: CallLogService,
   // private toastr : ToastrService,
    private aroute : ActivatedRoute,
    private router : Router,
    private gnotify : GlobalNotification
    //public dialogRef: MatDialogRef<CallLogDetailComponent>,
    //@Inject(MAT_DIALOG_DATA) public data : any
    ) {
     // console.log("CallLogDetailComponent");
      //this.dialogData = data;
    }
  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  getCountryString(code)
  {
    return GlobalConstants.getCountryString(code);
  }

  getCustomerString(type)
  {
    return GlobalConstants.getCustomerString(type);
  }

  ngOnInit() {
    this.userService.getUserList().subscribe(
      res=>{
        this.users = res as UserModel [];
        if(this.currentData)
        {
          this.currentData.createByUser = this.users.find(item => item.id === this.currentData.createBy);
        }

      },
      err=>{}
    );

    console.log("CallLogDetailComponent");
    this.sub = this.aroute.params.subscribe(params => {
      var id = params['id'];
      console.log("id : " + id);
      if(id != null)
      {
         this.service.getDetail(id).subscribe(
           res=>{
             this.currentData = res as CallDetailLogModel;
             if(this.users){
                this.currentData.createByUser = this.users.find(item => item.id === this.currentData.createBy);
             }
             this.form.setValue(CallDetailLogModel.convertToCallModel(this.currentData));

             this.loadIssueData(this.currentData.issueId, this.currentData.callId);
             this.loadClientData(this.currentData.clientId);
           },
           err=>{
             console.log(err);
           }
         );
      }

     });



  }

  loadIssueData(issueId, callId)
  {
    if(issueId != null)
    {
      this.issueService.getData(issueId).subscribe(
        res=>{
          this.issue =  res as IssueModel;
        }
      );
    }

    this.trackService.findDataByCall(callId).subscribe(
      res=>{
        this.issueTracks =  res as IssueTrackModel[];
      }
    );
  }

  loadClientData(id)
  {
    this.clientService.getDetail(id).subscribe(
      res=>
      {
          this.currentClient = res as ClientModel;
      },
      err=>{

      }
    );
  }

/*
  onClose() {

    this.service.form.reset();
    this.service.initializeFormGroup();
    this.dialogRef.close(false);
  }
*/
  onSubmit() {
    console.log("Callog onSubmit");

    if (!this.form.valid || !this.form.get('callId').value ) {
      ////this.toastr.success("Pleaes check all the medatory inputs.", "Invalid");
      this.gnotify.showSnackBar('Invalid', 'Pleaes check all the medatory inputs.', "success");
      return;
    }
    this.service.updateData(this.form.value).subscribe(
      res=>{
        //this.form.reset();
        //this.form.initializeFormGroup();
        ////this.toastr.success("Submit successfuly", "Call Log Modify");
        this.gnotify.showSnackBar('Call Log Modify', 'Submit successfuly.', "success");
        this.router.navigateByUrl('calllog');
      },
      err=>{
        console.log(err);
        ////this.toastr.error("Failed to Submit", "Call Log Modify");
        this.gnotify.showSnackBar('Call Log Modify', 'Failed to Submit.', "error");
      }
    );

  }

}
